
import router from './router/index'
import useStore from './store/index'
import { changeTitle } from './utils/changeTitle'


const whiteList = ['/login', '/401']
router.beforeEach(async (to, _, next) => {

    const { user } = useStore()

    const title = changeTitle(to.meta.title as string)
    document.title = title

    const token = user.token
    if (token) {
        if (to.path === '/login') {
            next('/')
        } else {
            next()
        }
    } else {
        // await user.clearLoginInfo()
        if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next()
        } else {
            next(`/login`)
        }
    }
})
